import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from "../../redux/slices/mainDataSlice";
import axios from "axios";
import RefillItemButton from "../../components/RefillItemButton";
import Can from "../../permissions/Can";
import Tooltip from "../../components/Tooltip";

export default function EmployeeList({ embedded, rgmw: propRgmw }) {
  const { rgmw: paramRgmw } = useParams();
  const rgmw = propRgmw || paramRgmw;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const jobs = useSelector((state) => state.main.data?.jobs || []);
  const schoolsData = useSelector((state) => state.main.data?.schoolData || []);

  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const schoolInfo = schoolsData.find(
    (school) => String(school.rgmw) === String(rgmw)
  );
  const schoolName = schoolInfo?.schoolname || "غير معروف";

  useEffect(() => {
    const fetchEmployees = async () => {

      try {
        const res = await axios.post(
          "https://api.alfares.cloud/api/newproject/getAllEmployees",
          {
            rgmw: Number(rgmw),
            fields: [
              "emp_id",
              "emp_name",
              "rgmw",
              "W_Num",
              "emp_gender",
              "itemnumber",
              "empmrkz",
              "nickname",
              "phone1",
              "place_birth",
              "birth_date",
            ],
          }
        );
        setEmployees(res.data.employees || []);
      } catch {
        toast.error("فشل في تحميل الموظفين");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [rgmw]);

  const handleEdit = (emp_id) => {
    navigate(`/editEmployee/${emp_id}`);
  };

  const handleDelete = async (emp_id, emp_name) => {
    try {
      const credentials = JSON.parse(localStorage.getItem("userCredentials"));
      const token = credentials?.token;

      if (!token) {
        toast.error("مفقود التوكن! يرجى تسجيل الدخول من جديد.");
        return;
      }

      toast(
        (t) => (
          <div style={{ fontFamily: "Cairo, sans-serif", textAlign: "center" }}>
            <div>هل تريد حذف الموظف:</div>
            <div style={{ color: "red", fontWeight: "bold", margin: "5px 0" }}>
              {emp_name}
            </div>
            <div
              style={{
                marginTop: 10,
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <button
                onClick={async () => {
                  try {
                    await axios.delete(
                      `https://api.alfares.cloud/api/alfares/deleteEmployee/${emp_id}/${token}`
                    );
                    toast.success("تم الحذف بنجاح");
                    setEmployees((prev) =>
                      prev.filter((e) => String(e.emp_id) !== String(emp_id))
                    );
                    dispatch(fetchData(true));
                  } catch {
                    toast.error("حصل خطأ أثناء الحذف");
                  } finally {
                    toast.dismiss(t.id);
                  }
                }}
                style={{
                  backgroundColor: "#d32f2f",
                  color: "white",
                  padding: "6px 14px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontFamily: "Cairo, sans-serif",
                }}
              >
                حذف
              </button>
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{
                  backgroundColor: "#ccc",
                  color: "black",
                  padding: "6px 14px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontFamily: "Cairo, sans-serif",
                }}
              >
                إلغاء
              </button>
            </div>
          </div>
        ),
        { duration: 8000 }
      );
    } catch {
      toast.error("حصل خطأ أثناء الحذف");
    }
  };

  const handleAdd = () => {
    navigate(`/editEmployee/new?mode=add&rgmw=${rgmw}`);
  };

  const jobNameById = (id) =>
    jobs.find((job) => Number(job.WathID) === Number(id))?.W_Name ||
    "بلا وظيفة";

  const getJobBadgeClass = (jobName) => {
    if (!jobName) return "job-badge--default";
    const name = jobName.trim();
    if (name.includes("مدير") && !name.includes("نائب"))
      return "job-badge--manager";
    if (name.includes("نائب")) return "job-badge--deputy";
    if (name.includes("سكرتير")) return "job-badge--secretary";
    if (name.includes("آذن") || name.includes("اذن") || name.includes("حارس"))
      return "job-badge--worker";
    return "job-badge--default";
  };

  const filtered = employees.filter((e) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return String(e.emp_name || "")
      .toLowerCase()
      .includes(q);
  });

  const formatBirthDate = (value) => {
    if (!value || value === "null" || value === "undefined") return null;
    const date = new Date(value);
    if (isNaN(date.getTime()) || date.getFullYear() < 1900) return null;
    return date.toISOString().split("T")[0];
  };

  return (
    <div className={embedded ? "embedded-component" : "employee-list-page"}>
      {!embedded && (
        <div className="employee-toolbar">
          <div className="toolbar-top">
            <div className="school-badge">
              <i className="fa-solid fa-school"></i>
              <span>{schoolName}</span>
              <span className="stats-inline">({employees.length})</span>
            </div>
          </div>

          <div className="toolbar-actions">
            <div className="action-buttons">
              <RefillItemButton
                rgmw={rgmw}
                className="btn btn--primary"
                style={{ height: "40px", margin: 0, flex: 1 }}
              />
              <Can module="employees" action="add">
              <button
                className="btn btn--primary"
                onClick={handleAdd}
                type="button"
                style={{
                  height: "40px",
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
              >
                <i className="fa-solid fa-user-plus"></i>
                <span>إضافة موظف</span>
              </button>
              </Can>
            </div>
          </div>
        </div>
      )}

      <style>{`
        /* Toolbar for embedded mode in SchoolDetails */
        .employee-list-header {
          direction: rtl;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          margin-bottom: 15px;
          border-bottom: 1px solid var(--border);
        }

        .employee-list-info {
          display: flex;
          align-items: center;
          gap: 10px;
          color: var(--text);
          font-weight: 700;
          font-size: 15px;
        }

        .employee-list-info i {
          color: var(--accent);
          font-size: 16px;
        }

        .employee-list-actions {
          display: flex;
          align-items: center;
          gap: 10px;
          height: 38px;
        }

        .search-wrapper-embedded {
          position: relative;
          margin-bottom: 15px;
          width: 100%;
        }

        .search-wrapper-embedded i {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--muted);
          font-size: 14px;
        }

        .search-wrapper-embedded input {
          width: 100%;
          height: 38px;
          padding: 0 35px 0 15px;
          background: var(--panel-2);
          border: 1px solid var(--border);
          border-radius: 10px;
          color: var(--text);
          font-size: 14px;
          outline: none;
          box-sizing: border-box;
        }

        /* الجدول في وضع الكمبيوتر */
        .employee-table-wrapper {
          width: 100%;
          overflow-x: auto;
          background: var(--panel);
          border-radius: 12px;
          border: 1px solid var(--border);
          margin-top: 10px;
          padding: 2px;
          box-sizing: border-box;
        }

        .employee-table {
          width: 100%;
          border-collapse: collapse;
          text-align: right;
          font-size: 13px;
          table-layout: auto;
        }

        .employee-table th {
          background: var(--panel-2);
          padding: 12px 10px;
          color: var(--accent);
          font-weight: 700;
          border-bottom: 1px solid var(--border);
          white-space: nowrap;
        }

        .employee-table td {
          padding: 10px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          color: var(--text);
          white-space: nowrap;
        }

        .employee-table tr:hover {
          background: rgba(255, 255, 255, 0.02);
        }

        .table-actions {
          display: flex;
          gap: 6px;
          justify-content: center;
        }

        .btn-table {
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          border: 1px solid var(--border);
          background: var(--panel-2);
          cursor: pointer;
          transition: 0.2s;
          font-size: 14px;
        }

        .btn-table--edit { color: var(--accent); }
        .btn-table--edit:hover { 
          background: var(--accent); 
          color: white; 
          border-color: var(--accent); 
        }
        .btn-table--edit:hover i {
          animation: bounce 0.6s infinite;
        }

        .btn-table--delete { color: var(--danger); }
        .btn-table--delete:hover { 
          background: var(--danger); 
          color: white; 
          border-color: var(--danger); 
        }
        .btn-table--delete:hover i {
          animation: shake 0.5s ease-in-out infinite;
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-3px); }
        }

        @keyframes shake {
          0% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          50% { transform: rotate(10deg); }
          75% { transform: rotate(-5deg); }
          100% { transform: rotate(0deg); }
        }

        .btn-emp-action {
          height: 38px;
          padding: 0 16px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          cursor: pointer;
          transition: 0.2s;
          border: 1px solid var(--border);
          background: var(--panel-2);
          color: var(--text);
          min-width: 120px;
        }

        .btn-emp-action:hover {
          background: var(--panel);
          border-color: var(--accent);
          color: var(--accent);
        }

        .btn-emp-action--add {
          border-color: rgba(16, 185, 129, 0.3);
          background: rgba(16, 185, 129, 0.05);
          font-family: "Cairo", sans-serif !important;
        }

        .btn-emp-action--add:hover {
          background: rgba(16, 185, 129, 0.1);
          border-color: #10b981;
          color: #10b981;
        }

        @media (max-width: 768px) {
          .employee-list-header {
            flex-direction: row;
            padding: 10px 0;
          }
          .employee-list-info span {
            display: none;
          }
          .btn-emp-action {
            min-width: 0;
            flex: 1;
            padding: 0 8px;
          }
          /* Icon-only buttons on mobile */
          .btn-emp-action.btn--icon-mobile {
            flex: none !important;
            width: 38px !important;
            min-width: 38px !important;
            padding: 0 !important;
          }
          .btn-emp-action.btn--icon-mobile .btn-label {
            display: none !important;
          }
          .employee-card__actions .btn--icon-mobile {
            width: 38px !important;
            min-width: 38px !important;
            padding: 0 !important;
            gap: 0 !important;
          }
          .employee-card__actions .btn--icon-mobile .btn-label {
            display: none !important;
          }
        }

        .job-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 2px 8px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
          border: none;
        }

        .job-badge--manager {
          color: #ef4444;
          background: transparent;
        }

        .job-badge--deputy {
          color: #3b82f6;
          background: transparent;
        }

        .job-badge--secretary {
          color: #10b981;
          background: transparent;
        }

        .job-badge--worker {
          color: #eab308;
          background: transparent;
        }

        .job-badge--default {
          color: #0ea5e9;
          background: transparent;
        }

        .gender-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 2px 8px;
          font-size: 13px;
          font-weight: 500;
          background: transparent;
          border: none;
        }

        .gender-badge--male {
          color: #3b82f6;
        }

        .gender-badge--female {
          color: #ec4899;
        }

        .gender-badge i {
          font-size: 13px;
        }

        /* الكروت في وضع الهاتف */
        .cards-grid {
          display: none;
        }

        @media (max-width: 1024px) {
          .employee-table-wrapper {
            display: none;
          }
          .cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 10px;
          }
        }

        .employee-card {
          padding: 8px 12px !important;
          display: flex !important;
          flex-direction: row !important; /* Side by side */
          align-items: center !important;
          justify-content: space-between !important;
          gap: 15px !important;
          background: var(--panel-2);
          border: 1px solid var(--border);
          border-radius: 10px;
          height: auto !important;
          min-height: 0 !important;
          width: 100%;
          box-sizing: border-box;
        }

        .employee-card__title {
          margin: 0 !important;
          font-size: 14px !important; /* Reduced by 1 (was 15px) */
          font-weight: 500 !important;
          color: var(--text);
          flex: 1;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .emp-index {
          color: var(--muted);
          font-size: 12px;
          font-weight: normal;
          min-width: 20px;
        }

        .employee-card__actions {
          display: flex !important;
          gap: 8px !important;
          flex: none !important;
        }

        .btn--compact {
          height: 32px !important;
          padding: 0 12px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 6px !important;
          border-radius: 8px !important;
          font-size: 13px !important;
          width: auto !important;
          min-width: 0 !important;
          white-space: nowrap;
        }

        .btn--compact i {
          font-size: 12px !important;
        }

        @media (max-width: 480px) {
          .cards-grid {
            grid-template-columns: 1fr;
          }
          .employee-card {
            padding: 10px !important;
          }
          .employee-card__title {
            font-size: 14px !important;
          }
          .btn--compact {
            padding: 0 8px !important;
            font-size: 12px !important;
            gap: 4px !important;
          }
        }

        .loading-full-width {
          width: 100% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 12px !important;
          padding: 40px !important;
          background: var(--panel-2) !important;
          border-radius: 12px !important;
          border: 1px dashed var(--border) !important;
          color: var(--accent) !important;
          font-weight: 600 !important;
          font-size: 16px !important;
          margin: 20px 0 !important;
        }

        .loading-full-width i {
          font-size: 22px !important;
        }
      `}</style>

      {embedded && (
        <>
          <div className="employee-list-header">
            <div className="employee-list-info">
              <i className="fa-solid fa-users"></i>
              <span>قائمة الموظفين ({employees.length})</span>
            </div>

            <div className="employee-list-actions">
              <RefillItemButton
                rgmw={rgmw}
                className="btn-emp-action"
                style={{ flex: 1 }}
              />
              <Can module="employees" action="add">
              <Tooltip content="إضافة موظف">
                <button
                  className="btn-emp-action btn-emp-action--add btn--icon-mobile"
                  onClick={handleAdd}
                  type="button"
               
                  style={{ fontFamily: "Cairo, sans-serif", flex: 2 }}
                >
                  <i className="fa-solid fa-user-plus"></i>
                  <span className="btn-label">إضافة موظف</span>
                </button>
              </Tooltip>
              </Can>
            </div>
          </div>

          <div className="search-wrapper-embedded">
            <i className="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              placeholder="بحث سريع في أسماء الموظفين..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </>
      )}

      {loading ? (
        <div className="badge loading-full-width">
          <i className="fa-solid fa-spinner fa-spin"></i>
          جاري تحميل بيانات الموظفين...
        </div>
      ) : filtered.length === 0 ? (
        <div className="badge">لا يوجد موظفين</div>
      ) : (
        <>
          {/* عرض الجدول في وضع الكمبيوتر */}
          <div className="employee-table-wrapper">
            <table className="employee-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>الاسم</th>
                  <th>رقم الهوية</th>
                  <th>الوظيفة</th>
                  <th>اسم الشهرة</th>
                  <th>رقم الهاتف</th>
                  <th>الجنس</th>
                  <th>مكان الولادة</th>
                  <th>تاريخ الولادة</th>
                  <th>إجراءات</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((employee, index) => (
                  <tr key={`${employee.emp_id}-${employee.empmrkz}`}>
                    <td>{index + 1}</td>
                    <td style={{ fontWeight: "600" }}>
                      {employee.emp_name || "—"}
                    </td>
                    <td>{employee.emp_id || "—"}</td>
                    <td>
                      <span
                        className={`job-badge ${getJobBadgeClass(
                          jobNameById(employee.W_Num)
                        )}`}
                      >
                        {jobNameById(employee.W_Num)}
                      </span>
                    </td>
                    <td>{employee.nickname || "—"}</td>
                    <td>{employee.phone1 || "—"}</td>
                    <td>
                      {Number(employee.emp_gender) === 1 ? (
                        <span className="gender-badge gender-badge--male">
                          <i className="fa-solid fa-mars"></i> ذكر
                        </span>
                      ) : (
                        <span className="gender-badge gender-badge--female">
                          <i className="fa-solid fa-venus"></i> أنثى
                        </span>
                      )}
                    </td>
                    <td>{employee.place_birth || "—"}</td>
                    <td>{formatBirthDate(employee.birth_date) || "—"}</td>
                    <td>
                      <div className="table-actions">
                        <Tooltip content="تعديل">
                          <button
                            className="btn-table btn-table--edit"
                            onClick={() => handleEdit(employee.emp_id)}
                         
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        </Tooltip>
                        <Tooltip content="حذف">
                          <button
                            className="btn-table btn-table--delete"
                            onClick={() =>
                              handleDelete(employee.emp_id, employee.emp_name)
                            }
                         
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* عرض الكروت في وضع الهاتف */}
          <div className="cards-grid">
            {filtered.map((employee, index) => {
              return (
                <div
                  key={`${employee.emp_id}-${employee.empmrkz}`}
                  className="employee-card"
                >
                  <h3 className="employee-card__title">
                    <span className="emp-index">{index + 1}.</span>
                    {employee.emp_name || "—"}
                  </h3>

                  <div className="employee-card__actions">
                    <Tooltip content="تعديل">
                      <button
                        className="btn btn--compact btn--icon-mobile"
                        onClick={() => handleEdit(employee.emp_id)}
                        type="button"
                     
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                        <span className="btn-label">تعديل</span>
                      </button>
                    </Tooltip>
                    <Tooltip content="حذف">
                      <button
                        className="btn btn--danger btn--compact btn--icon-mobile"
                        onClick={() =>
                          handleDelete(employee.emp_id, employee.emp_name)
                        }
                        type="button"
                     
                      >
                        <i className="fa-solid fa-trash-can"></i>
                        <span className="btn-label">حذف</span>
                      </button>
                    </Tooltip>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
